export enum EEmisniPodminky {
    NE = 'NE',
    UMED = 'UMED',
    UMDD = 'UMDD',
    UMPS = 'UMPS',
    UPSUMJ = 'UPSUMJ',
    UPEMPO = 'UPEMPO',
    UPDMPO = 'UPDMPO',
    UPEDPO = 'UPEDPO',
    NOSV = 'NOSV',
    NOSVE = 'NOSVE',
    NODSVD = 'NODSVD',
    UMP = 'UMP'
}
